{
	"Title": "MTGデッキ",
	"Head_MyDeck": "マイデッキ",
	"Head_DeckBuilder": "デッキ構築",
	"Head_SearchSetting": "検索設定",
	"Head_CardSearch": "カード検索",
	"Head_Option": "オプション",
	"MyDeck_AddDeck": "デッキ追加",
	"MyDeck_DeckName": "デッキ名",
	"MyDeck_InputDeckName": "デッキ名を入力",
	"Option_About": "このサイトについて",
	"Option_UpdateHistory": "更新履歴",
	"Option_PrivacyPolicy": "プライバシーポリシー",
	"Option_SupportForm": "お問い合わせ",
	"SaveLocalTitle": "注意",
	"SaveLocalDesc": "更新が新しいローカルセーブで上書きしますか？",
	"SaveStoreTitle": "注意",
	"SaveStoreDesc": "サーバセーブで上書きしますか？ローカルセーブは消えます。",
	"Common_Yes": "はい",
	"Common_No": "いいえ",
	"Common_OK": "決定",
	"Common_NG": "取消",
	"Common_Previous": "前へ",
	"Common_Next": "次へ",
	"Common_Attention": "注意",
	"Common_Warning": "警告",
	"Common_Upload": "アップロード",
	"Common_Download": "ダウンロード",
	"Common_Save": "保存",
	"Common_Load": "読込",
	"Common_Open": "開く",
	"Common_Close": "閉じる",
	"Common_Delete": "削除",
	"Common_Trash": "🗑️",
	"Common_Information": "情報",
	"Common_Total": "合計",
	"Common_Include": "包括",
	"Common_Exclude": "除外",
	"Common_Other": "その他",
	"Common_Login": "ログイン",
	"Common_LoginNow": "ログイン中",
	"Common_Logout": "ログアウト",
	"Common_Account": "アカウント",
	"Common_DeleteAccount": "退会",
	"Common_DeleteSave": "セーブ削除",
	"Common_Copy": "コピー",
	"Common_Paste": "貼り付け",
	"MTGA_Import": "MTGAインポート",
	"MTGA_Export": "MTGAエクスポート",
	"DeleteAccountAsk": "退会しますか？",
	"DeleteSaveAsk": "セーブ削除しますか？",
	"LoginGoogle": "Googleのアカウントでログイン",
	"AddCard": "カード追加",
	"ClearCard": "カードクリア",
	"AddGroup": "グループ追加",
	"DeleteGroup": "グループ削除",
	"DeleteGroupAsk": "グループを削除しますか？",
	"SupportForm_Desc": "ご要望、不具合のご報告などがありましたら、こちらのフォームからお送りください",
	"SupportForm_Email": "名前",
	"SupportForm_Message": "メッセージ",
	"SupportForm_Attention": "メッセージは{0}文字以下にしてください。",
	"Card_Language": "言語",
	"Card_Set": "カードセット",
	"Card_Name": "カード名",
	"Card_ArtifactType": "アーティファクト・タイプ",
	"Card_EnchantmentType": "エンチャント・タイプ",
	"Card_LandType": "土地タイプ",
	"Card_SpellType": "呪文タイプ",
	"Card_CreatureType": "クリーチャー・タイプ",
	"Card_BattleType": "バトル・タイプ",
	"Card_FrameEffect": "枠効果",
	"Card_KeywordAbility": "キーワード能力",
	"Card_ColorIdentity": "固有色",
	"CardType_Creature": "クリーチャー",
	"CardType_Artifact": "アーティファクト",
	"CardType_Enchantment": "エンチャント",
	"CardType_Land": "土地",
	"CardType_Instant": "インスタント",
	"CardType_Sorcery": "ソーサリー",
	"CardType_Planeswalker": "プレインズウォーカー",
	"Supertype_null": "特殊タイプなし",
	"Supertype_legendary": "伝説",
	"Supertype_world": "ワールド",
	"Supertype_basic": "基本",
	"Rarity_common": "コモン",
	"Rarity_uncommon": "アンコモン",
	"Rarity_rare": "レア",
	"Rarity_mythic": "神話レア",
	"CardAvailability_paper": "紙",
	"CardAvailability_arena": "アリーナ",
	"CardAvailability_mtgo": "MTGO",
	"About_References": "参考",
	"About_Message": "このサイトは Magic: The Gathering の非公式ファンコンテンツです。\n\nデッキ構築ツールで、趣味と勉強を兼ねて作りました。\n\n紙のカードが増えて探すの大変、MTGAのコマンダー版が欲しいなと思い作りました。\n\n在庫、欲しいカードの管理などにも使えれば嬉しいです。 カードを見るのも楽しいです。\n\n更新は不定期ですが、温かく見守っていただけると嬉しいです。 ぜひご要望やご感想をお寄せください。",
	"Right_MTG_Description": "魅力的なトレーディングカードゲームです。",
	"Right_MTGJSON_Description": "データベースを使わせて頂いております。",
	"Right_Scryfall_Description": "カード画像を使わせて頂いております。",
	"Right_Bootstrap_Description": "サイトのデザインで使わせて頂いております。",
	"Right_Pragmatic_Description": "Atlassian の Trelloライブラリ。これでMTGA風デッキ構築ページを作っています。",
	"Keyword_Absorb": "吸収",
	"Keyword_Affinity": "親和",
	"Keyword_Afflict": "加虐",
	"Keyword_Afterlife": "死後",
	"Keyword_Aftermath": "余波",
	"Keyword_Amplify": "増幅",
	"Keyword_Annihilator": "滅殺",
	"Keyword_Ascend": "昇殿",
	"Keyword_Assist": "助力",
	"Keyword_Augment": "拡張",
	"Keyword_Aura Swap": "オーラ交換",
	"Keyword_Awaken": "覚醒",
	"Keyword_Backup": "賛助",
	"Keyword_Banding": "バンド",
	"Keyword_Bargain": "協約",
	"Keyword_Basic landcycling": "基本土地サイクリング",
	"Keyword_Battle Cry": "喊声",
	"Keyword_Bestow": "授与",
	"Keyword_Blitz": "奇襲",
	"Keyword_Bloodthirst": "狂喜",
	"Keyword_Boast": "誇示",
	"Keyword_Bushido": "武士道",
	"Keyword_Buyback": "バイバック",
	"Keyword_Cascade": "続唱",
	"Keyword_Casualty": "犠牲",
	"Keyword_Champion": "覇権",
	"Keyword_Changeling": "多相",
	"Keyword_Choose a background": "背景選択",
	"Keyword_Cipher": "暗号",
	"Keyword_Cleave": "切除",
	"Keyword_Commander ninjutsu": "上忍術",
	"Keyword_Companion": "相棒",
	"Keyword_Compleated": "完成化",
	"Keyword_Conspire": "共謀",
	"Keyword_Convoke": "召集",
	"Keyword_Craft": "作製",
	"Keyword_Crew": "搭乗",
	"Keyword_Cumulative upkeep": "累加アップキープ",
	"Keyword_Cycling": "サイクリング",
	"Keyword_Dash": "疾駆",
	"Keyword_Daybound": "日暮",
	"Keyword_Deathtouch": "接死",
	"Keyword_Decayed": "腐乱",
	"Keyword_Defender": "防衛",
	"Keyword_Delve": "探査",
	"Keyword_Demonstrate": "実演",
	"Keyword_Desertwalk": "砂漠渡り",
	"Keyword_Dethrone": "廃位",
	"Keyword_Devoid": "欠色",
	"Keyword_Devour": "貪食",
	"Keyword_Disguise": "変装",
	"Keyword_Disturb": "降霊",
	"Keyword_Doctor's companion": "ドクターのコンパニオン",
	"Keyword_Double agenda": "両策",
	"Keyword_Double strike": "二段攻撃",
	"Keyword_Double team": "二体掛り",
	"Keyword_Dredge": "発掘",
	"Keyword_Echo": "エコー",
	"Keyword_Embalm": "不朽",
	"Keyword_Emerge": "現出",
	"Keyword_Enchant": "エンチャント",
	"Keyword_Encore": "再演",
	"Keyword_Enlist": "後援",
	"Keyword_Entwine": "双呪",
	"Keyword_Epic": "歴伝",
	"Keyword_Equip": "装備",
	"Keyword_Escalate": "増呪",
	"Keyword_Escape": "脱出",
	"Keyword_Eternalize": "永遠",
	"Keyword_Evoke": "想起",
	"Keyword_Evolve": "進化",
	"Keyword_Exalted": "賛美",
	"Keyword_Exhaust": "消尽",
	"Keyword_Exploit": "濫用",
	"Keyword_Extort": "強請",
	"Keyword_Fabricate": "製造",
	"Keyword_Fading": "消散",
	"Keyword_Fear": "畏怖",
	"Keyword_Firebending": "火の技",
	"Keyword_First strike": "先制攻撃",
	"Keyword_Flanking": "側面攻撃",
	"Keyword_Flash": "瞬足",
	"Keyword_Flashback": "フラッシュバック",
	"Keyword_Flying": "飛行",
	"Keyword_For Mirrodin!": "ミラディンのために！",
	"Keyword_Forecast": "予見",
	"Keyword_Forestcycling": "森サイクリング",
	"Keyword_Forestwalk": "森渡り",
	"Keyword_Foretell": "予顕",
	"Keyword_Fortify": "城砦化",
	"Keyword_Freerunning": "フリーランニング",
	"Keyword_Frenzy": "激情",
	"Keyword_Friends forever": "共闘 ─ 永遠の友",
	"Keyword_Fuse": "融合",
	"Keyword_Gift": "贈呈",
	"Keyword_Graft": "移植",
	"Keyword_Gravestorm": "墓地ストーム",
	"Keyword_Harmonize": "調和",
	"Keyword_Haste": "速攻",
	"Keyword_Haunt": "憑依",
	"Keyword_Hexproof": "呪禁",
	"Keyword_Hexproof from": "～からの呪禁",
	"Keyword_Hidden agenda": "秘策",
	"Keyword_Hideaway": "秘匿",
	"Keyword_Horsemanship": "馬術",
	"Keyword_Impending": "兆候",
	"Keyword_Improvise": "即席",
	"Keyword_Indestructible": "破壊不能",
	"Keyword_Infect": "感染",
	"Keyword_Ingest": "嚥下",
	"Keyword_Intensity": "強度",
	"Keyword_Intimidate": "威嚇",
	"Keyword_Islandcycling": "島サイクリング",
	"Keyword_Islandwalk": "島渡り",
	"Keyword_Job select": "ジョブ選択",
	"Keyword_Jump-start": "再活",
	"Keyword_Kicker": "キッカー",
	"Keyword_Landcycling": "土地サイクリング",
	"Keyword_Landwalk": "土地渡り",
	"Keyword_Legendary landwalk": "伝説の土地渡り",
	"Keyword_Level Up": "Lvアップ",
	"Keyword_Lifelink": "絆魂",
	"Keyword_Living metal": "金属生命体",
	"Keyword_Living weapon": "生体武器",
	"Keyword_Madness": "マッドネス",
	"Keyword_Max speed": "最高速度",
	"Keyword_Mayhem": "大混乱",
	"Keyword_Megamorph": "大変異",
	"Keyword_Melee": "会戦",
	"Keyword_Menace": "威迫",
	"Keyword_Mentor": "教導",
	"Keyword_Miracle": "奇跡",
	"Keyword_Mobilize": "応召",
	"Keyword_Modular": "接合",
	"Keyword_More Than Meets the Eye": "見た目以上のもの",
	"Keyword_Morph": "変異",
	"Keyword_Mountaincycling": "山サイクリング",
	"Keyword_Mountainwalk": "山渡り",
	"Keyword_Multikicker": "多重キッカー",
	"Keyword_Mutate": "変容",
	"Keyword_Myriad": "無尽",
	"Keyword_Nightbound": "夜明",
	"Keyword_Ninjutsu": "忍術",
	"Keyword_Nonbasic landwalk": "基本でない土地渡り",
	"Keyword_Offering": "献身",
	"Keyword_Offspring": "新生",
	"Keyword_Outlast": "長久",
	"Keyword_Overload": "超過",
	"Keyword_Partner": "共闘",
	"Keyword_Partner with": "〜との共闘",
	"Keyword_Persist": "頑強",
	"Keyword_Phasing": "フェイジング",
	"Keyword_Plainscycling": "平地サイクリング",
	"Keyword_Plainswalk": "平地渡り",
	"Keyword_Poisonous": "有毒",
	"Keyword_Protection": "プロテクション",
	"Keyword_Prototype": "試作",
	"Keyword_Provoke": "挑発",
	"Keyword_Prowess": "果敢",
	"Keyword_Prowl": "徘徊",
	"Keyword_Rampage": "ランページ",
	"Keyword_Ravenous": "貪欲",
	"Keyword_Reach": "到達",
	"Keyword_Read Ahead": "先読",
	"Keyword_Rebound": "反復",
	"Keyword_Reconfigure": "換装",
	"Keyword_Recover": "復活",
	"Keyword_Reinforce": "補強",
	"Keyword_Renown": "高名",
	"Keyword_Replicate": "複製",
	"Keyword_Retrace": "回顧",
	"Keyword_Riot": "暴動",
	"Keyword_Ripple": "波及",
	"Keyword_Saddle": "騎乗",
	"Keyword_Scavenge": "活用",
	"Keyword_Shadow": "シャドー",
	"Keyword_Shroud": "被覆",
	"Keyword_Skulk": "潜伏",
	"Keyword_Slivercycling": "スリヴァー・サイクリング",
	"Keyword_Soulbond": "結魂",
	"Keyword_Soulshift": "転生",
	"Keyword_Specialize": "専門化",
	"Keyword_Spectacle": "絢爛",
	"Keyword_Splice": "連繋",
	"Keyword_Split second": "刹那",
	"Keyword_Spree": "放題",
	"Keyword_Squad": "分隊",
	"Keyword_Station": "配備",
	"Keyword_Storm": "ストーム",
	"Keyword_Sunburst": "烈日",
	"Keyword_Surge": "怒濤",
	"Keyword_Suspend": "待機",
	"Keyword_Swampcycling": "沼サイクリング",
	"Keyword_Swampwalk": "沼渡り",
	"Keyword_Toxic": "毒性",
	"Keyword_Training": "訓練",
	"Keyword_Trample": "トランプル",
	"Keyword_Transfigure": "変形",
	"Keyword_Transmute": "変成",
	"Keyword_Tribute": "貢納",
	"Keyword_Typecycling": "タイプ・サイクリング",
	"Keyword_Umbra armor": "陰影鎧",
	"Keyword_Undaunted": "不抜",
	"Keyword_Undying": "不死",
	"Keyword_Unearth": "蘇生",
	"Keyword_Unleash": "解鎖",
	"Keyword_Vanishing": "消失",
	"Keyword_Vigilance": "警戒",
	"Keyword_Ward": "護法",
	"Keyword_Warp": "ワープ",
	"Keyword_Web-slinging": "ウェブスリング",
	"Keyword_Wither": "Wither",
	"Keyword_Wizardcycling": "ウィザード・サイクリング",
	"Subtype_Attraction": "アトラクション",
	"Subtype_Blood": "血",
	"Subtype_Clue": "手掛かり",
	"Subtype_Contraption": "からくり",
	"Subtype_Equipment": "装備品",
	"Subtype_Food": "食物",
	"Subtype_Fortification": "城砦",
	"Subtype_Gold": "金",
	"Subtype_Incubator": "培養器",
	"Subtype_Map": "地図",
	"Subtype_Powerstone": "パワーストーン",
	"Subtype_Treasure": "宝物",
	"Subtype_Vehicle": "機体",
	"Subtype_Aura": "オーラ",
	"Subtype_Background": "背景",
	"Subtype_Cartouche": "カルトーシュ",
	"Subtype_Class": "クラス",
	"Subtype_Curse": "呪い",
	"Subtype_Role": "役割",
	"Subtype_Rune": "ルーン",
	"Subtype_Saga": "英雄譚",
	"Subtype_Shard": "破片",
	"Subtype_Shrine": "祭殿",
	"Subtype_Desert": "砂漠",
	"Subtype_Forest": "森",
	"Subtype_Gate": "門",
	"Subtype_Island": "島",
	"Subtype_Lair": "棲み家",
	"Subtype_Locus": "神座",
	"Subtype_Mine": "鉱山",
	"Subtype_Mountain": "山",
	"Subtype_Plains": "平地",
	"Subtype_Power-Plant": "魔力炉",
	"Subtype_Sphere": "球層",
	"Subtype_Swamp": "沼",
	"Subtype_Tower": "塔",
	"Subtype_Urza's": "ウルザの",
	"Subtype_Adventure": "出来事",
	"Subtype_Arcane": "秘儀",
	"Subtype_Lesson": "講義",
	"Subtype_Trap": "罠",
	"Subtype_Advisor": "アドバイザー",
	"Subtype_Aetherborn": "霊基体",
	"Subtype_Alien": "エイリアン",
	"Subtype_Ally": "同盟者",
	"Subtype_Angel": "天使",
	"Subtype_Antelope": "アンテロープ",
	"Subtype_Ape": "類人猿",
	"Subtype_Archer": "射手",
	"Subtype_Archon": "執政官",
	"Subtype_Army": "軍団",
	"Subtype_Artificer": "工匠",
	"Subtype_Assassin": "暗殺者",
	"Subtype_Assembly-Worker": "組立作業員",
	"Subtype_Astartes": "アスタルテス",
	"Subtype_Atog": "エイトグ",
	"Subtype_Aurochs": "オーロクス",
	"Subtype_Avatar": "アバター",
	"Subtype_Azra": "アズラ",
	"Subtype_Badger": "アナグマ",
	"Subtype_Balloon": "風船",
	"Subtype_Barbarian": "バーバリアン",
	"Subtype_Bard": "バード",
	"Subtype_Basilisk": "バジリスク",
	"Subtype_Bat": "コウモリ",
	"Subtype_Bear": "熊",
	"Subtype_Beast": "ビースト",
	"Subtype_Beeble": "ビーブル",
	"Subtype_Beholder": "ビホルダー",
	"Subtype_Berserker": "狂戦士",
	"Subtype_Bird": "鳥",
	"Subtype_Boar": "猪",
	"Subtype_Bringer": "運び手",
	"Subtype_Brushwagg": "ブラッシュワグ",
	"Subtype_Camel": "ラクダ",
	"Subtype_Capybara": "カピバラ",
	"Subtype_Carrier": "キャリアー",
	"Subtype_Cat": "猫",
	"Subtype_Centaur": "ケンタウルス",
	"Subtype_Cephalid": "セファリッド",
	"Subtype_Child": "子供",
	"Subtype_Chimera": "キマイラ",
	"Subtype_Citizen": "市民",
	"Subtype_Cleric": "クレリック",
	"Subtype_Clown": "道化師",
	"Subtype_Cockatrice": "コカトリス",
	"Subtype_Construct": "構築物",
	"Subtype_Coward": "臆病者",
	"Subtype_Crab": "カニ",
	"Subtype_Crocodile": "クロコダイル",
	"Subtype_Custodes": "近衛団",
	"Subtype_Cyberman": "サイバーマン",
	"Subtype_Cyclops": "サイクロプス",
	"Subtype_Dalek": "ダーレク",
	"Subtype_Dauthi": "ダウスィー",
	"Subtype_Demigod": "亜神",
	"Subtype_Demon": "デーモン",
	"Subtype_Designer": "脱走者",
	"Subtype_Detective": "探偵",
	"Subtype_Devil": "デビル",
	"Subtype_Dinosaur": "恐竜",
	"Subtype_Djinn": "ジン",
	"Subtype_Doctor": "ドクター",
	"Subtype_Dog": "犬",
	"Subtype_Dragon": "ドラゴン",
	"Subtype_Drake": "ドレイク",
	"Subtype_Dreadnought": "ドレッドノート",
	"Subtype_Drone": "ドローン",
	"Subtype_Druid": "ドルイド",
	"Subtype_Dryad": "ドライアド",
	"Subtype_Dwarf": "ドワーフ",
	"Subtype_Efreet": "イフリート",
	"Subtype_Egg": "卵",
	"Subtype_Elder": "エルダー",
	"Subtype_Eldrazi": "エルドラージ",
	"Subtype_Elemental": "エレメンタル",
	"Subtype_Elephant": "象",
	"Subtype_Elf": "エルフ",
	"Subtype_Elk": "大鹿",
	"Subtype_Employee": "従業員",
	"Subtype_Eye": "眼",
	"Subtype_Faerie": "フェアリー",
	"Subtype_Ferret": "フェレット",
	"Subtype_Fish": "魚",
	"Subtype_Flagbearer": "旗手",
	"Subtype_Fox": "狐",
	"Subtype_Fractal": "フラクタル",
	"Subtype_Frog": "カエル",
	"Subtype_Fungus": "ファンガス",
	"Subtype_Gamer": "ゲーマー",
	"Subtype_Gargoyle": "ガーゴイル",
	"Subtype_Germ": "細菌",
	"Subtype_Giant": "巨人",
	"Subtype_Gith": "ギス",
	"Subtype_Gnoll": "ノール",
	"Subtype_Gnome": "ノーム",
	"Subtype_Goat": "ヤギ",
	"Subtype_Goblin": "ゴブリン",
	"Subtype_God": "神",
	"Subtype_Golem": "ゴーレム",
	"Subtype_Gorgon": "ゴルゴン",
	"Subtype_Graveborn": "墓生まれ",
	"Subtype_Gremlin": "グレムリン",
	"Subtype_Griffin": "グリフィン",
	"Subtype_Guest": "ゲスト",
	"Subtype_Hag": "ハッグ",
	"Subtype_Halfling": "ハーフリング",
	"Subtype_Hamster": "ハムスター",
	"Subtype_Harpy": "ハーピー",
	"Subtype_Hellion": "ヘリオン",
	"Subtype_Hippo": "カバ",
	"Subtype_Hippogriff": "ヒポグリフ",
	"Subtype_Homarid": "ホマリッド",
	"Subtype_Homunculus": "ホムンクルス",
	"Subtype_Horror": "ホラー",
	"Subtype_Horse": "馬",
	"Subtype_Human": "人間",
	"Subtype_Hydra": "ハイドラ",
	"Subtype_Hyena": "ハイエナ",
	"Subtype_Illusion": "イリュージョン",
	"Subtype_Imp": "インプ",
	"Subtype_Incarnation": "インカーネーション",
	"Subtype_Inkling": "墨獣",
	"Subtype_Inquisitor": "異端審問官",
	"Subtype_Insect": "昆虫",
	"Subtype_Jackal": "ジャッカル",
	"Subtype_Jellyfish": "クラゲ",
	"Subtype_Juggernaut": "巨大戦車",
	"Subtype_Kavu": "カヴー",
	"Subtype_Kirin": "麒麟",
	"Subtype_Kithkin": "キスキン",
	"Subtype_Knight": "騎士",
	"Subtype_Kobold": "コボルド",
	"Subtype_Kor": "コー",
	"Subtype_Kraken": "クラーケン",
	"Subtype_Lamia": "ラミア",
	"Subtype_Lammasu": "ラマスー",
	"Subtype_Leech": "ヒル",
	"Subtype_Leviathan": "リバイアサン",
	"Subtype_Lhurgoyf": "ルアゴイフ",
	"Subtype_Licid": "リシド",
	"Subtype_Lizard": "トカゲ",
	"Subtype_Manticore": "マンティコア",
	"Subtype_Masticore": "マスティコア",
	"Subtype_Mercenary": "傭兵",
	"Subtype_Merfolk": "マーフォーク",
	"Subtype_Metathran": "メタスラン",
	"Subtype_Minion": "ミニオン",
	"Subtype_Minotaur": "ミノタウルス",
	"Subtype_Mite": "ダニ",
	"Subtype_Mole": "モグラ",
	"Subtype_Monger": "モンガー",
	"Subtype_Mongoose": "マングース",
	"Subtype_Monk": "モンク",
	"Subtype_Monkey": "猿",
	"Subtype_Moonfolk": "ムーンフォーク",
	"Subtype_Mouse": "ハツカネズミ",
	"Subtype_Mutant": "ミュータント",
	"Subtype_Myr": "マイア",
	"Subtype_Mystic": "神秘家",
	"Subtype_Naga": "ナーガ",
	"Subtype_Nautilus": "オウムガイ",
	"Subtype_Necron": "ネクロン",
	"Subtype_Nephilim": "ネフィリム",
	"Subtype_Nightmare": "ナイトメア",
	"Subtype_Nightstalker": "夜魔",
	"Subtype_Ninja": "忍者",
	"Subtype_Noble": "貴族",
	"Subtype_Noggle": "ノッグル",
	"Subtype_Nomad": "ノーマッド",
	"Subtype_Nymph": "ニンフ",
	"Subtype_Octopus": "タコ",
	"Subtype_Ogre": "オーガ",
	"Subtype_Ooze": "ウーズ",
	"Subtype_Orc": "オーク",
	"Subtype_Orgg": "オーグ",
	"Subtype_Otter": "カワウソ",
	"Subtype_Ouphe": "アウフ",
	"Subtype_Ox": "雄牛",
	"Subtype_Oyster": "カキ",
	"Subtype_Pangolin": "センザンコウ",
	"Subtype_Peasant": "農民",
	"Subtype_Pegasus": "ペガサス",
	"Subtype_Pentavite": "ペンタバイト",
	"Subtype_Performer": "パフォーマー",
	"Subtype_Pest": "邪魔者",
	"Subtype_Phelddagrif": "フェルダグリフ",
	"Subtype_Phoenix": "フェニックス",
	"Subtype_Phyrexian": "ファイレクシアン",
	"Subtype_Pilot": "操縦士",
	"Subtype_Pirate": "海賊",
	"Subtype_Plant": "植物",
	"Subtype_Praetor": "法務官",
	"Subtype_Primarch": "総主長",
	"Subtype_Processor": "昇華者",
	"Subtype_Rabbit": "兎",
	"Subtype_Raccoon": "アライグマ",
	"Subtype_Ranger": "レインジャー",
	"Subtype_Rat": "ネズミ",
	"Subtype_Rebel": "レベル",
	"Subtype_Reflection": "反射",
	"Subtype_Rhino": "サイ",
	"Subtype_Rigger": "装具工",
	"Subtype_Robot": "ロボット",
	"Subtype_Rogue": "ならず者",
	"Subtype_Sable": "黒貂",
	"Subtype_Salamander": "サラマンダー",
	"Subtype_Samurai": "侍",
	"Subtype_Sand": "砂漠の民",
	"Subtype_Saproling": "苗木",
	"Subtype_Satyr": "サテュロス",
	"Subtype_Scarecrow": "カカシ",
	"Subtype_Scientist": "科学者",
	"Subtype_Scion": "末裔",
	"Subtype_Scorpion": "蠍",
	"Subtype_Scout": "スカウト",
	"Subtype_Sculpture": "彫像",
	"Subtype_Serf": "農奴",
	"Subtype_Serpent": "海蛇",
	"Subtype_Servo": "霊気装置",
	"Subtype_Shade": "シェイド",
	"Subtype_Shaman": "シャーマン",
	"Subtype_Shapeshifter": "多相の戦士",
	"Subtype_Shark": "サメ",
	"Subtype_Sheep": "羊",
	"Subtype_Siren": "セイレーン",
	"Subtype_Skeleton": "スケルトン",
	"Subtype_Slith": "スリス",
	"Subtype_Sliver": "スリヴァー",
	"Subtype_Slug": "ナメクジ",
	"Subtype_Snail": "カタツムリ",
	"Subtype_Snake": "蛇",
	"Subtype_Soldier": "兵士",
	"Subtype_Soltari": "サルタリー",
	"Subtype_Spawn": "落とし子",
	"Subtype_Specter": "スペクター",
	"Subtype_Spellshaper": "スペルシェイパー",
	"Subtype_Sphinx": "スフィンクス",
	"Subtype_Spider": "蜘蛛",
	"Subtype_Spike": "スパイク",
	"Subtype_Spirit": "スピリット",
	"Subtype_Splinter": "裂片",
	"Subtype_Sponge": "スポンジ",
	"Subtype_Squid": "イカ",
	"Subtype_Squirrel": "リス",
	"Subtype_Starfish": "ヒトデ",
	"Subtype_Surrakar": "サラカー",
	"Subtype_Survivor": "生存者",
	"Subtype_Tentacle": "触手",
	"Subtype_Thalakos": "サラカス",
	"Subtype_Thopter": "飛行機械",
	"Subtype_Thrull": "スラル",
	"Subtype_Tiefling": "ティーフリング",
	"Subtype_Time Lord": "タイムロード",
	"Subtype_Treefolk": "ツリーフォーク",
	"Subtype_Trilobite": "三葉虫",
	"Subtype_Triskelavite": "トリスケラバイト",
	"Subtype_Troll": "トロール",
	"Subtype_Turtle": "海亀",
	"Subtype_Tyranid": "ティラニッド",
	"Subtype_Unicorn": "ユニコーン",
	"Subtype_Vampire": "吸血鬼",
	"Subtype_Vedalken": "ヴィダルケン",
	"Subtype_Volver": "ボルバー",
	"Subtype_Wall": "壁",
	"Subtype_Walrus": "セイウチ",
	"Subtype_Warlock": "邪術師",
	"Subtype_Warrior": "戦士",
	"Subtype_Weird": "奇魔",
	"Subtype_Werewolf": "狼男",
	"Subtype_Whale": "鯨",
	"Subtype_Wizard": "ウィザード",
	"Subtype_Wolf": "狼",
	"Subtype_Wolverine": "クズリ",
	"Subtype_Wombat": "ウォンバット",
	"Subtype_Worm": "蟲",
	"Subtype_Wraith": "レイス",
	"Subtype_Wurm": "ワーム",
	"Subtype_Yeti": "イエティ",
	"Subtype_Zombie": "ゾンビ",
	"Subtype_Zubera": "ずべら",
	"Subtype_Siege": "包囲戦",
	"FrameEffect_null": "なし",
	"FrameEffect_enchantment": "エンチャント",
	"FrameEffect_etched": "エッチング",
	"FrameEffect_extendedart": "拡張アート",
	"FrameEffect_fullart": "フルアート",
	"FrameEffect_inverted": "反転",
	"FrameEffect_legendary": "伝説",
	"FrameEffect_lesson": "講義",
	"FrameEffect_showcase": "ショーケース",
	"FrameEffect_snow": "氷雪"
}